"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Drawer/index.ts
var Drawer_exports = {};
__export(Drawer_exports, {
  Drawer: () => Drawer,
  default: () => Drawer
});
module.exports = __toCommonJS(Drawer_exports);

// src/components/Drawer/Drawer.tsx
var import_react3 = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));

// src/hook/use-detect-outside-click-hook.ts
var import_react = require("react");
function useDetectOutsideClick({
  container = document,
  containerRef,
  onDetect
}, deps) {
  (0, import_react.useEffect)(() => {
    if (!(containerRef == null ? void 0 : containerRef.current))
      return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        onDetect == null ? void 0 : onDetect();
      }
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleClickOutside);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef, ...deps]);
}

// src/components/Drawer/DrawerContext.tsx
var import_react2 = require("react");
var DrawerContext = (0, import_react2.createContext)({});

// src/components/Drawer/Drawer.tsx
var getClassNames = (props) => {
  const {
    open,
    anchor,
    className,
    contentClassName,
    modalClassName,
    anchorY,
    anchorX,
    overlayOpacity
  } = props;
  return {
    container: (0, import_classnames.default)(
      ["v2-flex v2-absolute v2-overflow-hidden v2-z-50"],
      {
        "v2-pointer-events-none": !open,
        "v2-top-0": anchor === "top",
        "v2-right-0 v2-top-0": anchor === "right",
        "v2-bottom-0": anchor === "bottom",
        "v2-left-0 v2-top-0": anchor === "left",
        "v2-w-full": anchorY,
        "v2-h-full": anchorX
      },
      className
    ),
    content: (0, import_classnames.default)(
      ["v2-ease-out-in v2-transition-transform v2-grow v2-relative"],
      {
        "v2-translate-y-[-100%]": !open && anchor === "top",
        "v2-translate-x-[100%]": !open && anchor === "right",
        "v2-translate-y-[100%]": !open && anchor === "bottom",
        "v2-translate-x-[-100%]": !open && anchor === "left",
        "v2-translate-x-0": open && anchorX,
        "v2-translate-y-0": open && anchorY
      },
      contentClassName
    ),
    modal: (0, import_classnames.default)(
      [
        "v2-absolute v2-w-full v2-h-full v2-z-40",
        "v2-ease-out-in v2-transition-opacity",
        "v2-bg-black"
      ],
      {
        "v2-opacity-0 v2-pointer-events-none": !open,
        "v2-block": open,
        "v2-opacity-10": overlayOpacity === "low" /* Low */,
        "v2-bg-opacity-50": overlayOpacity === "medium" /* Medium */,
        "v2-bg-opacity-70": overlayOpacity === "high" /* High */,
        "v2-hidden": props.noModal
      },
      modalClassName
    )
  };
};
var getStyles = (props) => {
  const { anchorX, anchorY, drawerDepth, slideDuration } = props;
  const transitionDuration = `${slideDuration != null ? slideDuration : 150}ms`;
  return {
    container: {
      width: anchorX && (drawerDepth != null ? drawerDepth : "auto") || void 0,
      height: anchorY && (drawerDepth != null ? drawerDepth : "auto") || void 0
    },
    content: {
      transitionDuration
    },
    modal: {
      transitionDuration
    }
  };
};
function Drawer(props) {
  const { closeOnEsc = false } = props;
  const extraProps = (0, import_react3.useMemo)(() => {
    const anchorX = ["left", "right"].includes(props.anchor);
    const anchorY = ["top", "bottom"].includes(props.anchor);
    return {
      anchorX,
      anchorY
    };
  }, [props.anchor]);
  const { classNames, styles } = (0, import_react3.useMemo)(() => {
    const allProps = __spreadValues(__spreadValues({}, props), extraProps);
    const classNames2 = getClassNames(allProps);
    const styles2 = getStyles(allProps);
    return {
      classNames: classNames2,
      styles: styles2
    };
  }, [props, extraProps]);
  const contentRef = (0, import_react3.useRef)(null);
  (0, import_react3.useEffect)(() => {
    if (!closeOnEsc)
      return;
    const handleEscKey = (event) => {
      var _a;
      if (event.key === "Escape" && props.open) {
        (_a = props.onClose) == null ? void 0 : _a.call(props);
      }
    };
    document.addEventListener("keydown", handleEscKey);
    return () => document.removeEventListener("keydown", handleEscKey);
  }, [props.open, props.onClose, closeOnEsc]);
  useDetectOutsideClick(
    {
      containerRef: contentRef,
      onDetect: () => {
        var _a;
        if (props.open && !props.disableAutoClose) {
          (_a = props.onClose) == null ? void 0 : _a.call(props);
        }
      }
    },
    [props.open, props.onClose]
  );
  const drawerContext = {
    close: () => {
      var _a;
      return (_a = props.onClose) == null ? void 0 : _a.call(props);
    }
  };
  return /* @__PURE__ */ import_react3.default.createElement(DrawerContext.Provider, { value: drawerContext }, /* @__PURE__ */ import_react3.default.createElement("div", { className: classNames.container, style: styles.container }, /* @__PURE__ */ import_react3.default.createElement(
    "div",
    {
      ref: contentRef,
      className: classNames.content,
      style: styles.content
    },
    props.children
  )), /* @__PURE__ */ import_react3.default.createElement("div", { className: classNames.modal, style: styles.modal }));
}
